import { message } from "antd";

export const checkUploadConditions = (file: any) => {
    const fileSize = file.size;

    if (fileSize > 5 * 1000 * 1000 * 1000) {
        message.warning("For files bigger than 5 GB, please use the CLI upload utility.", 2);
        return false;
    }

    const re = /(?:\.([^.]+))?$/;
    const tempArray = re.exec(file.name);
    if (!tempArray) return false;
    if (
        tempArray[1] !== "las" &&
        tempArray[1] !== "laz" &&
        tempArray[1] !== "LAS" &&
        tempArray[1] !== "LAZ" &&
        tempArray[1] !== "e57"
    ) {
        message.warning("File type not supported.", 2);
        return false;
    }

    return true;
};